import { GridStack } from 'gridstack';

import utils from './utils';
import graphics from './graphics';
import ReportUtils from './reports';

class ReportEditor {
    constructor()
    {
        this.grid = null;
        this.reports = new ReportUtils();
    }

    initReportEditor(container)
    {
        let editor = $('#report-layout', container);
        if (editor.length > 0) {
            this.grid = GridStack.init({
                minRow: 1,
                acceptWidgets: true,
                removable: '#trash',
                cellHeight: '80px'
            });

            GridStack.setupDragIn('.newWidget', {
                appendTo: 'body',
                helper: 'clone'
            });

            /*
                Grid's contents have to be loaded and inited before the
                assignment of events' triggers, otherwise triggers themselves
                are applied also on existing cells (which would be replaced with
                "new widget" cells)
            */

            this.grid.load(window.layout);
            this.reports.loadCells(this.grid, container, 'passive', null);

            this.grid.on('added', (e, items) => {
                for (let i = 0; i < items.length; i++) {
                    let node = $(items[i].el);
                    this.handleNewCell(node);
                }
            });

            this.grid.on('removed change', (e) => {
                this.saveReport();
            });

            $('.preview-selector', container).on('click', 'ul a', (e) => {
                e.preventDefault();
                let t = $(e.currentTarget);
                let url = t.attr('href');
                let text = t.text();
                t.closest('.preview-selector').find('.trigger').attr('href', url).text(text);
            });
        }

        /*
            The following block is dynamically executed on the form to create
            and edit widgets within a report
        */
        if (container.attr('id') == 'edit_widget') {
            /*
                When creating a new widget, only the "type" selector is
                displayed. When the type is selected, the rest of the form is
                dynamically loaded with the proper details
            */
            $('[name=type], [name=target_type]', container).change((e) => {
                let select = $(e.currentTarget);
                let form = select.closest('form');
                graphics.blurForm(form);

                $.ajax({
                    url: select.attr('data-fetch-url'),
                    method: 'GET',
                    data: form.serialize(),
                    dataType: 'HTML',
                    success: function(data) {
                        data = $(data);
                        utils.j().initElements(data);
                        form.find('.widget-details').empty().append(data);
                        graphics.unblurForm(form);
                    }
                });
            });

            /*
                This is executed when the editing form is submitted: the whole
                form is serialized and sent to the server, where each field is
                properly managed accordily the widget's type, and the "passive"
                visualization is returned to be placed into the grid.
            */
            $('form', container).submit((e) => {
                let form = $(e.currentTarget);

                /*
                    To prevent double click on the submit button, leading to
                    disasters
                */
                utils.j().submitButton(form).prop('disabled', true);

                e.preventDefault();
                e.stopPropagation();

                $.ajax({
                    url: form.attr('action'),
                    method: form.attr('method'),
                    dataType: 'HTML',
                    data: form.serialize(),
                    success: (cell) => {
                        let editing = $('.now-editing');

                        /*
                            If, for any condition, there are more than a single
                            widget marked as "editing", the whole operation is
                            aborted and the page reloaded. This is to avoid
                            weird overlaps, occurred in different (undocumented
                            and non reproducible) situations
                        */
                        if (editing.length > 1) {
                            window.location.reload();
                        }

                        this.grid.update(editing.closest('.grid-stack-item').get(0), {
                            content: cell
                        });

                        utils.j().initElements(editing);
                        editing.removeClass('now-editing').removeClass('d-flex');

                        form.closest('.modal').modal('hide');
                        this.saveReport();
                    }
                });
            });

            container.on('hide.bs.modal', () => {
                $('.now-editing').removeClass('now-editing');
            });

            container.on('change', '.pie-dynamic-selection select[name=target]', (e) => {
                let select = $(e.currentTarget);
                let target = select.val();
                let new_options = widget_list_parameters[target];
                let selections = container.find('select[name=measure]');
                selections.empty();
                new_options.forEach((opt) => {
                    selections.append('<option value="' + opt.value + '">' + opt.label + '</option>');
                });
            });
        }

        $('.edit-widget', container).click((e) => {
            $('.now-editing').removeClass('now-editing');
            $(e.currentTarget).closest('.widget').addClass('now-editing');
        });

        /*
            Within multiple chart types editing ("mixed" or "group" widgets)
            this is to display the "style" option only when "line" chart type is
            selected
        */
        $('select[name^=chart]', container).each(function() {
            let type = $(this).val();
            $(this).closest('tr').find('select[name^=style]').toggle(type == 'line');
        }).change((e) => {
            let type = $(e.currentTarget).val();
            $(e.currentTarget).closest('tr').find('select[name^=style]').toggle(type == 'line');
        });
    }

    handleNewCell(node)
    {
        let new_node = $('#templates .empty-widget').clone();
        new_node.find('.jb-in').removeClass('jb-in');
        utils.j().initElements(new_node);
        node.removeClass('newWidget').removeClass('has-hand').find('.grid-stack-item-content').attr('class', 'grid-stack-item-content widget').empty().append(new_node);
    }

    saveReport()
    {
        let form = $('#master-edit-report');
        let layout = this.grid.save();

        layout = layout.map((e) => {
            let cell = $(e.content);
            e.content = '<div data-widget-id="' + cell.attr('data-widget-id') + '"></div>';
            return e;
        });

        let data = new FormData(form.get(0));
        data.append('layout', JSON.stringify(layout));

        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            processData: false,
            contentType: false,
            dataType: 'JSON',
            data: data,
            success: (res) => {
                utils.feedbackToast('Auto Saved!', 'success');
            },
            error: () => {
                utils.feedbackToast('Error in Auto Save!', 'danger');
            }
        });
    }
}

export default ReportEditor;
